export default __webpack_public_path__ + "static/media/croped_img2.553de9d3.jpeg";